import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

const NO_RESPONSE_MSG =
  'There was error without response text from API endpoint';

export default {
  getDetails(e: Error, addMessage: string): string {
    const response = get(e, 'xhr.responseText');
    let noResponseMessage = NO_RESPONSE_MSG;
    if (!isNil(response)) {
      const moreInfo = getMoreInfo(e);
      if (isJson(response)) {
        let details = '';
        const error = JSON.parse(response);
        if (!isEmpty(error.errorMessages)) {
          details += error.errorMessages.reduce(
            (previousValue, currentValue) => {
              return previousValue + currentValue;
            }
          );
        }

        return details + '\n' + moreInfo;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(response, 'text/html');

      return doc.body.innerHTML.replace(/<\/?[^>]+>/gi, '\n') + moreInfo;
    } else if (e.message) {
      if (addMessage) {
        noResponseMessage = e.message;
      } else {
        noResponseMessage = null;
      }
    }

    return noResponseMessage;
  },
};

function getMoreInfo(e) {
  const source = getValueAtPathOfError(e, 'source', 'Error caused by: ');
  const status = getValueAtPathOfError(e, 'xhr.status', 'HTTP status: ');

  return source + '\n' + status;
}

function getValueAtPathOfError(e, path, prefix) {
  const value = get(e, path, null);
  if (isNumber(value) || (isString(value) && !isEmpty(value))) {
    return prefix + value + '.';
  }
  return '';
}

function isJson(s: string) {
  try {
    JSON.parse(s);
    return true;
  } catch (e) {
    return false;
  }
}
